export default function AdvertorialTag() {
  return (
    <div className="inline-block h-8 w-[144px] rounded-[30px] border border-solid border-mglGray500 text-center text-xs font-medium uppercase leading-8 text-mglGray500">
      PUBLIEDITORIAL
    </div>
  );
}
